import {
	Component,
	OnInit,
	ViewChildren,
	PLATFORM_ID,
	ViewChild,
	AfterViewInit,
	ChangeDetectorRef,
	HostListener,
} from '@angular/core';
import { Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

// ** rxjs
import { finalize, switchMap, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

// ** service
import { LayoutService } from '@app/core/services/layout.service';
import { AboutService } from '@app/core/services/about.service';
import { LanguageService } from '@app/core/services';

import { SwiperComponent } from 'swiper/angular';

import SwiperCore, { EffectFade, Navigation, Thumbs, Scrollbar, Autoplay } from 'swiper';
SwiperCore.use([EffectFade, Navigation, Thumbs, Scrollbar, Autoplay]);

@Component({
	templateUrl: './aboutkypage.component.html',
	styleUrls: ['./aboutkypage.component.scss'],
})
export class AboutkypageComponent implements OnInit, AfterViewInit {
	@ViewChildren('staffSummary') staffSummary;
	@ViewChild(SwiperComponent, { static: false }) swiper: SwiperComponent;

	isBrowser: boolean;
	thumbsSwiperBanner: any;
	thumbsSwiperRelation: any;

	// ** swiper current 頁數 reference
	swiperPageRef = 1;
	// ** swiper 顯示的數量
	perPage = 3;
	// ** swiper 是否顯示
	showSwiper = false;

	// ** 針對 staff summary 的 css property (show)
	showSumProp = {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		padding: '1.25rem',
		pointerEvents: 'none',
		color: 'white',
	};

	// ** 針對 staff summary 的 css property (hide)
	hideSumProp = {
		display: 'unset',
		width: '0',
		height: '0',
		padding: 'unset',
		pointerEvents: 'none',
		fontSize: '0.875rem',
		lineHeight: 'unset',
		color: '#465161',
	};

	// ** 里程碑資料
	milestone = [];

	// ** 聯絡我們顯示與否
	contactFormShow = false;

	@HostListener('window:resize', ['$event'])
	onResize(event: Event): void {
		if (this.isBrowser) this.onWindowResize();
	}

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId,
		private cdr: ChangeDetectorRef,
		private aboutService: AboutService,
		private layoutService: LayoutService,
		private languageService: LanguageService
	) {
		// ** ssr/ssg 要先確保是不是在瀏覽器運行，避免 ref err
		this.isBrowser = isPlatformBrowser(this.platformId);
		if (this.isBrowser) this.onWindowResize();
	}

	ngOnInit(): void {
		const canonical = this.document.querySelector('link[rel="canonical"]') as HTMLAnchorElement | null;
		if (canonical) canonical.href = 'https://www.kunyoutech.com.tw/aboutKunYu';

		of(this.layoutService.setPageLoading(true))
			.pipe(
				tap((res) => this.getMilestones()),
				finalize(() => this.layoutService.setPageLoading(false))
			)
			.subscribe();
	}

	ngAfterViewInit(): void {
		this.initSwiper();
	}

	// - 初始化 swiper
	initSwiper() {
		setTimeout(() => (this.showSwiper = true));
		setTimeout(() => this.swiper?.swiperRef?.on('slideChange', (e) => this.updatePageIdx()));
	}

	// - 依據 window size 調整 swiper 顯示 slide 數量
	onWindowResize() {
		const lg = window.innerWidth > 1024;
		const md = window.innerWidth > 440 && window.innerWidth <= 1024;
		const sm = window.innerWidth <= 440;
		this.perPage = lg ? 3 : md ? 2 : sm ? 1 : 0;
		this.updateScroll();
	}

	// - 取得 milestone 資料
	getMilestones() {
		of(this.layoutService.setPageLoading(true))
			.pipe(
				switchMap(() => this.getMilestones$()),
				tap((res) => (this.milestone = res)),
				finalize(() => this.layoutService.setPageLoading(false))
			)
			.subscribe();
	}

	// - 顯示 staff sum on hover
	displaySummary(idx, e) {
		if (this.isBrowser && window.innerWidth < 440) return;
		const subjectEle = this.staffSummary._results[idx].nativeElement;
		Object.keys(this.showSumProp).forEach((key) => (subjectEle.style[key] = this.showSumProp[key]));
		subjectEle.style.height = e.target.offsetHeight + 'px';
		subjectEle.style.fontSize = subjectEle.offsetWidth < 160 ? '1rem' : '1rem';
	}

	// - 隱藏 staff sum on hover
	hideSummary(idx) {
		if (this.isBrowser && window.innerWidth < 440) return;
		const subjectEle = this.staffSummary._results[idx].nativeElement.style;
		Object.keys(this.hideSumProp).forEach((key) => (subjectEle[key] = this.hideSumProp[key]));
	}

	// - 更新品牌優勢幻燈片
	updatePageIdx() {
		setTimeout(() => {
			this.swiperPageRef = this.swiper?.swiperRef ? this.swiper?.swiperRef.activeIndex + 1 : 1;
			this.cdr.detectChanges();
		});
	}

	// - manual update swiper scroll for ng lifecycle hotfix
	updateScroll() {
		setTimeout(() => {
			this.swiper?.swiperRef?.scrollbar.updateSize();
			this.swiper?.swiperRef?.scrollbar.setTranslate();
		});
	}


	/**
	 * 當前語系是否為英文
	 */
	isEnglish(): boolean {
		return this.languageService.getCurrentLang() === 'en-us';
	}

	// ? api
	getMilestones$(): Observable<any> {
		return this.aboutService.getMilestones().pipe();
	}
}
